// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"81b28fed","466":"1f33e08a","566":"53438c0e","657":"f6a44bd6","726":"37ea88a4","767":"38a31b39"}[chunkId] + ".chunk.css";
};